import { useQuery } from '@tanstack/react-query'

import { useFlag } from '~/hooks/useFlag'
import { importUnScheduledSurgeries, importUnScheduledSurgeriesBySpecialties } from '~/store/dips-entity.api'
import { useStore } from '~/store/store'

import { useSentryLogging } from '../../shared/useSentryLogging'
import { MultiQueryOptions } from '../useMultiQuery'

export const UNSCHEDULED_SURGERIES_QUERYKEY_PREFIX = 'unscheduledSurgeries'

/**
 * Fetch all unscheduled surgeries and put them in the store.
 *
 * IMPORTANT: if you need surgery metadata, use `useUnscheduledSurgeriesAndMetadataQueries` instead.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useUnscheduledSurgeriesQuery = (options?: MultiQueryOptions) => {
    const isSpecialtiesSelectionEnabled = useFlag('use_specialties_selection')
    const departmentKey = useStore(state => state.appFilters.departmentKey)
    const selectedSpecialties = useStore(state => state.appFilters.selectedSpecialties)

    const queryKeyInput = isSpecialtiesSelectionEnabled ? selectedSpecialties : departmentKey

    const unscheduledSurgeriesQuery = useQuery({
        queryFn: () =>
            isSpecialtiesSelectionEnabled ? importUnScheduledSurgeriesBySpecialties(selectedSpecialties) : importUnScheduledSurgeries(departmentKey),
        queryKey: [UNSCHEDULED_SURGERIES_QUERYKEY_PREFIX, queryKeyInput],
        enabled: !options?.skip,
        refetchInterval: options?.refetchInterval,
        staleTime: options?.staleTime,
    })

    useSentryLogging({ key: 'useUnscheduledSurgeriesQuery', queryResult: unscheduledSurgeriesQuery })

    return unscheduledSurgeriesQuery
}
